import React, { useEffect } from 'react';
import SectionForm from '../../components/general/SectionForm';
import { IDepartment } from '../../constants/types';
import { useDispatch, useSelector } from 'react-redux';
import { postSubmissionPatientAction, updateSubmissionPatientAction, deleteSubmissionPatientAction, stopTreatmentPatientAction } from '../../redux/actions/submissionsPatientActions';
import Loader from '../../components/Loader';
import { usePrevious } from '../../hooks';
import { MatrixForm } from './patient/Forms/Matrix';
import { cloneDeep } from 'lodash';

interface FillSurveyProps {
    idSubmission?:number,
    sectionSelected?:number,
    sections:any[],
    uuid: string,
    initData?:any,
    country:string,
    uuidInvestigation:string,
    uuidPatient:string,
    requestServiceId?:string,
    nameSurvey?:string,
    typeSurvey?:string,
    department?:IDepartment,
    hideButtonsSubmit?:boolean,
    alterSubmitButton?: (button:JSX.Element) => JSX.Element,
    callBackDataCollectionSaved?: () => void
    callBackDataCollectionSavedWithData?:(data:any) => void
}

const FillSurvey: React.FC<FillSurveyProps> = ({ sectionSelected, uuid, sections, initData, 
                                                idSubmission, requestServiceId, nameSurvey,
                                                country, uuidInvestigation, uuidPatient, department, typeSurvey, hideButtonsSubmit,
                                                alterSubmitButton, callBackDataCollectionSaved, callBackDataCollectionSavedWithData }) => {
    const [loading, setLoading] = React.useState(false);
    const emptyArray:any[] = [];                                                    
    const submissionsSurvey = useSelector((state:any) => {
        console.log(state);
        if(state.patientsSubmissions.data && state.patientsSubmissions.data[uuidPatient] && state.patientsSubmissions.data[uuidPatient][uuid]){
            return state.patientsSubmissions.data[uuidPatient][uuid].submissions
        }
        return emptyArray;
    });
    const prevSubmissionsSurvey = usePrevious(submissionsSurvey, true);
    const dispatch = useDispatch();

    let fields:any[] = [];
    let sectionsSurvey = []
    if(sectionSelected){
        sectionsSurvey = [sectionSelected];
    }
    else{
        sectionsSurvey = sections;
    }

    useEffect(() => {
        if(callBackDataCollectionSavedWithData){
            const oldSubmissions = !prevSubmissionsSurvey ? [] : prevSubmissionsSurvey;
            if(submissionsSurvey.length !== oldSubmissions.length){
                const lastSubmission = submissionsSurvey[submissionsSurvey.length - 1];
                callBackDataCollectionSavedWithData(lastSubmission);
            }
            else if(idSubmission ){
                const oldSubmission = oldSubmissions.find((sub:any) => sub.id === idSubmission);
                const submission = submissionsSurvey.find((sub:any) => sub.id === idSubmission);
                if(submission && (oldSubmission && oldSubmission.updatedAt !== submission.updatedAt)){
                    callBackDataCollectionSavedWithData(submission);
                }
            }
        }
        
    }, [submissionsSurvey]);

    useEffect(() => {
        console.log("FillSurvey");
    }, []);


    async function saveTreatmentsWrapper(treatments: any[], forceNewSubmissionAddButton = false) {

        console.log("Saving treatments to database:", treatments);
        if (treatments.length === 0) {
            console.error("Treatments array is empty");
            return;
        }
        
        // Find the treatment_inpatient field
        let treatmentField = null;
        for (const section of sections) {
            treatmentField = section.fields.find((f: any) => f.type === "treatment_inpatient");
            if (treatmentField) {
                break;
            }
        }
        
        if (!treatmentField) {
            console.error("Treatment field not found");
            return;
        }
        
        // Format data in the same structure that saveRecords expects
        const dataFields = [{
            surveyField: {...treatmentField},
            value: treatments
        }];

        await saveRecords(dataFields, "button1", forceNewSubmissionAddButton);
    }

    async function saveRecords(data:any, buttonSubmitted:string, forceNewSubmissionAddButton = false){
        setLoading(true);
        let postObj:{
            uuidSurvey: string;
            uuid_patient: string;
            id: number | undefined;
            surveyRecords: any[];
            requestInfo?: {
                requestId: number;
                completeRequest: boolean;
            };
        } =  {
            uuidSurvey:uuid, 
            uuid_patient:uuidPatient,
            id:forceNewSubmissionAddButton ? undefined : idSubmission,
            surveyRecords:[]
        }
        if(requestServiceId){
            postObj = {
                uuidSurvey:uuid, 
                uuid_patient:uuidPatient,
                id:forceNewSubmissionAddButton ? undefined : idSubmission,
                surveyRecords:[],
                requestInfo: {
                    requestId:parseInt(requestServiceId), 
                    completeRequest:buttonSubmitted === "button2"
                },
            }
        }
        
        data.forEach((fieldData:any) => {
            //const sectionField = dataCollectionSelected.sections.find(section => section.fields.find(aField => aField.id === fieldData.surveyField.id));
            postObj.surveyRecords.push(fieldData); 
        });

        //If it is called from onUpdateDatabase, we weg the submission id
        if (!forceNewSubmissionAddButton && Array.isArray(postObj.surveyRecords[0]?.value) && postObj.surveyRecords[0]?.value?.[0]?.submission_id) {
            postObj.id = postObj.surveyRecords[0].value[0].submission_id;
            idSubmission = postObj.id;

            const { submission_id, createdAt, ...cleanedTreatment } = postObj.surveyRecords[0].value[0];
            postObj.surveyRecords[0].value[0] = cleanedTreatment;

            const treatmentData = postObj.surveyRecords?.[0]?.value?.[0];
            const simplifiedPayload = {
                "treatment-stoppedAt": treatmentData?.["treatment-stoppedAt"] || "",
                "treatment-stop_motive": treatmentData?.["treatment-stop_motive"] || ""
            };

            await dispatch(stopTreatmentPatientAction(simplifiedPayload, uuidInvestigation, uuidPatient, uuid, nameSurvey, idSubmission));
        }
        
        else if(idSubmission){
            // Si hay initData, estamos actualizando
            await dispatch(updateSubmissionPatientAction(postObj, uuidInvestigation, uuidPatient, uuid, nameSurvey, idSubmission));
        }
        else{
            await dispatch(postSubmissionPatientAction(postObj, uuidInvestigation, uuidPatient, uuid, nameSurvey, typeSurvey));
        }
        if(callBackDataCollectionSaved){
            callBackDataCollectionSaved();
        }
        
        setLoading(false);
        
    }

    async function deleteTreatment(treatment: any){
        setLoading(true);

        const submissionId = treatment.submission_id;
        const { submission_id, ...cleanedTreatment } = treatment;

        await dispatch(deleteSubmissionPatientAction(cleanedTreatment, uuidInvestigation, submissionId, uuidPatient, uuid));

        setLoading(false);
    }
    
    sectionsSurvey.sort((a,b) => a.order - b.order)
        .forEach((section, index) =>{
            // Deep clone the fields to avoid mutating Redux store
            let sectionFields = cloneDeep(section.fields).sort((a:any,b:any) => a.order - b.order)
    
            if((sectionFields.length === 1 || sectionFields[0].label === section.name)&& sectionFields[0].type !== "textarea"){
                sectionFields[0].label = `general.default-label.${sectionFields[0].type}`
            }
            sectionFields.unshift({
                type:"title_section",
                label:section.name,
                name:"title_section_"+index,
                required:false, 
                validation: "notEmpty",
                id:index
            });
            fields = fields.concat(sectionFields);

            if(nameSurvey === "BOWEL MOVEMENT CHART"){
                fields.splice(1, 0, {
                    type:"thumbnail",
                    label:"https://i0.wp.com/post.medicalnewstoday.com/wp-content/uploads/sites/3/2021/08/15970-bristol-stool-chart-1296x1394-english-body-952x1024.jpg?w=1155&h=2929",
                    value:"Bristol stool chart",
                    required:false, 
                    validation: "notEmpty",
                    id:1
                });
            }

            if(nameSurvey === "PAIN VAS"){
                fields.splice(1, 0, {
                    type:"thumbnail",
                    label:"https://michigantoday.umich.edu/wp-content/uploads/sites/89/2025/07/Health-Yourself-Pain-Assessment-Tool.png",
                    value:"Pain Assessment Tool",
                    required:false, 
                    validation: "notEmpty",
                    id:1
                });
            }
    })      
    if(loading){
        return <Loader />
    }
    if(nameSurvey === "MATRIX FORM"){
        return <MatrixForm survey={{ sections: sections, name: nameSurvey }}
        submissions={submissionsSurvey}
        isVisualizingMode={false}
        callbackSurveyCompleted={ (values:any) => {saveRecords(values, "button2")}}/>
    
    }
    return(
        <SectionForm key={uuid} initData={initData}
            country={country} uuidInvestigation={uuidInvestigation}
            fields={fields} uuidPatient={uuidPatient} department={department}
            uuidSurvey = {uuid} alterSubmitButton={alterSubmitButton}
            idSubmission={idSubmission}
            hideButtonsSubmit={hideButtonsSubmit}
            onSaveToDatabase={(treatment: any) => saveTreatmentsWrapper([treatment], true)}
            onUpdateDatabase={(treatment: any) => saveTreatmentsWrapper([treatment], false)}
            onDeleteDatabase={(treatment: any) => deleteTreatment(treatment)}
            callBackSectionForm = {(values:any, buttonSubmitted:any) => saveRecords(values, buttonSubmitted)}/>
    )
   
};

export default FillSurvey;
